import { render, staticRenderFns } from "./invoices.vue?vue&type=template&id=48b4f573&scoped=true&"
import script from "./invoices.vue?vue&type=script&lang=js&"
export * from "./invoices.vue?vue&type=script&lang=js&"
import style0 from "./invoices.vue?vue&type=style&index=0&id=48b4f573&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b4f573",
  null
  
)

export default component.exports